import { initializeApp } from 'firebase/app';
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
} from 'firebase/app-check';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import settings from '../config/settings';
import { connectFunctionsEmulator, getFunctions } from '@firebase/functions';
import { connectAuthEmulator, getAuth } from '@firebase/auth';
import { getDatabase } from 'firebase/database';

import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

const firebaseApp = initializeApp(settings.firebaseConfig);

const APP_CHECK_DEBUG_TOKEN_STORAGE_KEY = 'FIREBASE_APPCHECK_DEBUG_TOKEN';
const APP_CHECK_ENABLED_PROJECT_IDS = ['sayhelp-dfcea'];
const firebaseProjectId = String(settings.firebaseConfig.projectId || '').trim();

const isAppCheckEnabledProject = APP_CHECK_ENABLED_PROJECT_IDS.includes(
  firebaseProjectId
);

const enableDevelopmentAppCheckDebugToken = () => {
  if (typeof window === 'undefined') return;

  let debugToken = null;

  try {
    debugToken = window.localStorage.getItem(APP_CHECK_DEBUG_TOKEN_STORAGE_KEY);
  } catch {
    debugToken = null;
  }

  if (!debugToken) return;

  window.self.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
};

// Enable App Check debug mode for local development.
if (process.env.NODE_ENV === 'development' && isAppCheckEnabledProject) {
  enableDevelopmentAppCheckDebugToken();
}

// Initialize Google Analytics only in production
if (process.env.NODE_ENV === 'production') {
  getAnalytics(firebaseApp);
}

if (settings.recaptchaSiteKey && isAppCheckEnabledProject) {
  initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaV3Provider(settings.recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export const functions = getFunctions(firebaseApp);
export const auth = getAuth(firebaseApp);
export const firestore = getFirestore(firebaseApp);
export const database = getDatabase(firebaseApp);

export const storage = getStorage();

export const Timestamp = firestore.Timestamp;

// connectFirestoreEmulator(firestore, 'localhost', 8080);
// connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
// connectFunctionsEmulator(functions, 'localhost', 5001);
